import { useState, useEffect } from 'react';

export type LayoutType = 'mobile' | 'tablet' | 'desktop';
export type OrientationType = 'portrait' | 'landscape';

interface ResponsiveCTALayout {
  layout: LayoutType;
  orientation: OrientationType;
  isTouch: boolean;
  screenWidth: number;
  screenHeight: number;
}

export const useResponsiveCTAs = (): ResponsiveCTALayout => {
  const [layout, setLayout] = useState<LayoutType>('desktop');
  const [orientation, setOrientation] = useState<OrientationType>('landscape');
  const [isTouch, setIsTouch] = useState(false);
  const [screenWidth, setScreenWidth] = useState(0);
  const [screenHeight, setScreenHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setScreenWidth(width);
      setScreenHeight(height);

      // Determine layout based on viewport width
      if (width < 768) {
        setLayout('mobile');
      } else if (width < 1024) {
        setLayout('tablet');
      } else {
        setLayout('desktop');
      }

      // Determine orientation
      setOrientation(height > width ? 'portrait' : 'landscape');

      // Detect touch capability
      setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0);
    };

    // Initial setup
    handleResize();

    // Add event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return {
    layout,
    orientation,
    isTouch,
    screenWidth,
    screenHeight
  };
};